import { Modal, Button, Card, Row, Col, Space, Tooltip } from "antd";
import dayjs from "dayjs";
import { useState } from "react";

const SponsorPlanModal = ({ open, onClose, onSubmit }) => {
    const [plan, setPlan] = useState(null);

    const planOptions = [
        { id: 1, label: "3 Months", months: 3 },
        { id: 2, label: "6 Months", months: 6 },
        { id: 3, label: "12 Months", months: 12 },
    ];
    const planTooltips = {
    1: "Bronze",
    2: "Silver",
    3: "Gold",
};

    const handleConfirm = () => {
        const selected = planOptions.find((p) => p.id === plan);
        if (!selected) return;

        const start = dayjs();
        const end = start.add(selected.months, "month");

        onSubmit({
            fld_sponsorship_plan_id: selected.id,
            fld_sponsorship_plan_name: selected.label,
            fld_sponsorship_start_date: start.format("YYYY-MM-DD HH:mm:ss"),
            fld_sponsorship_end_date: end.format("YYYY-MM-DD HH:mm:ss"),
        });
    };

    return (
        <Modal
            open={open}
            title="Activate Sponsorship"
            onCancel={onClose}
            width={500}
            footer={[
                <Space>
                    <Button key="cancel" onClick={onClose}>Cancel</Button>

                    <Tooltip
                        title="Please choose a plan first"
                        placement="top"
                        trigger="hover"
                        disabled={!!plan}   
                    >
                        <span>
                            <Button
                                key="ok"
                                type="primary"
                                style={{ backgroundColor: "#0072b1" }}
                                disabled={!plan}
                                onClick={handleConfirm}
                            >
                                Activate
                            </Button>
                        </span>
                    </Tooltip>
                </Space>,
            ]}


        >
            <div style={{ marginBottom: 15, fontSize: 15 }}>
                Select a sponsorship duration:
            </div>

            <Row gutter={[16, 16]}>
                {planOptions.map((item) => (
                    <Col span={8} key={item.id}>
                         <Tooltip title={planTooltips[item.id]} placement="top">
                        <Card
                            hoverable
                            onClick={() => setPlan(item.id)}
                            style={{
                                borderRadius: 10,
                                border: plan === item.id ? "2px solid #0072b1" : "1px solid #e0e0e0",
                                textAlign: "center",
                                cursor: "pointer",
                                padding: 10,
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 16,
                                    fontWeight: 600,
                                    color: plan === item.id ? "#0072b1" : "#333",
                                }}
                            >
                                {item.label}
                            </div>
                        </Card>
                        </Tooltip>
                    </Col>
                ))}
            </Row>
        </Modal>
    );
};

export default SponsorPlanModal;
